module.exports = __webpack_public_path__ + "static/img/doc-icon.5bde03c9.svg";